(function() {

  
    window.CartPage = window.CartPage || new function() {
    //runs once per page load
    var self = this;
    
    self.updateCart = function() {
      $s.showLoadingOverlay();
      $s.getJson({url: '/?sections=cart_content', success: function(data){
        var section = document.querySelector('.cart-content');
        section.outerHTML = data['cart_content'];
        $s.globalEval(data['cart_content']);
        $s.hideLoadingOverlay();
      }});
    }

    self.updateItemsQuantity = function(items, quantity){
      var data = {updates: {}}
      items.forEach(function(item) {
        data.updates[item.dataset.key] = quantity;
      });
      postUpdate(data);
    }

     

    function postUpdate(data) {
      $s.showLoadingOverlay();
      $s.post({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: async function(cart) {$s.AutoAddRemoveProducts.runAllRules(JSON.parse(cart), true).then(function(response) {
              //self.updateCart();
              location.reload();
            });},
        error: $s.addToCartFail
      });
    }

    self.postChange = function(data) {
      $s.showLoadingOverlay();
      $s.post({
        type: 'POST',
        url: '/cart/change.js',
        data: data,
        dataType: 'json',
        success: async function(cart) {
          $s.AutoAddRemoveProducts.runAllRules(JSON.parse(cart), true).then(function(response) {
            //self.updateCart();
            location.reload();
          });
        },
        error: $s.addToCartFail
      });
    }

    self.postAdd = function(data) {
      $s.showLoadingOverlay();
      $s.post({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: async function(cart) {
          
          location.reload();
        },
        error: $s.addToCartFail
      });
    }
  
  };
  //runs every time #cart div is replaced
  var cart = document.getElementById('cart');
  var itemsCount = 0;
  cart.querySelectorAll('.cart-items .quantity-box input[type=number]').forEach(function(item){
    itemsCount += item.value/1;
  });
  document.querySelector('header .cart-count').innerHTML = itemsCount>0?window.cart_json.item_count:'0';

   /* REMOVE LAST BORDER ON ITEMS EXCLUDING PROMO DIVS */
   var itemLength = 0;
   cart.querySelectorAll('.item').forEach((item) => {
     let cssObj = window.getComputedStyle(item, null);
     let display = cssObj.getPropertyValue("display");
     if (display !== 'none') {
       itemLength++
     }
   })

  cart.querySelectorAll('.remove').forEach(function(item) {
    item.addEventListener('click', function(e){
      e.preventDefault();
      var items = $s.getItemsToUpdate(this.closest('.item'), 0);
      CartPage.updateItemsQuantity(items, 0);
    });
  });

  cart.querySelectorAll('.cart-items input[type=number]').forEach(function(item) {
    item.addEventListener('change', function(e){
      var items = $s.getItemsToUpdate(this.closest('.item'), this.value);
      CartPage.updateItemsQuantity(items, this.value);
    });
  });

  cart.querySelectorAll('.toogle-next').forEach((button) => {
    button.addEventListener('click', () => {
      $s.toggle([button.nextElementSibling]);
    });
  });$s.validateBundlesInHTML(document.querySelectorAll('#cart .item'));
  })();